module.exports = __webpack_public_path__ + "static/media/hers.d37e1ceb.webp";